import { undo, redo } from 'prosemirror-history';
import { keymap } from 'prosemirror-keymap';

const historyKeymap = keymap({
	'Mod-z': undo,
	'Mod-y': redo,
});

export default historyKeymap;
